<template>
    <div class="mobile-navbar grid grid__base" :class="bemFacets">
        <div class="grid--container grid--container__fluid">
            <div class="mobile-navbar--row grid--row">
                <a href="/" class="u-reset grid--col mobile-navbar--brand-link">
                    <slot name="brand-logo"/>
                </a>

                <button class="u-reset hamburger hamburger--spin"
                        type="button"
                        :class="buttonClasses"
                        @click="$emit('toggle')">
                    <span class="hamburger-box">
                        <span class="hamburger-inner"/>
                    </span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>

    import bemMixin from 'framework/mixins/bem';

    export default {
        mixins: [bemMixin('mobile-navbar')],
        props: {
            isMenuOpen: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            buttonClasses() {
                return this.isMenuOpen ? 'is-active' : 'hamburger__dark';
            },
        },

    };
</script>
